import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Configuração do Firebase usando variáveis de ambiente
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBn3Jk0-F5r9wkpjBQ9PIakCAyWBmr3ysM",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "advocaciasaas.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "advocaciasaas",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "advocaciasaas.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "987415322427",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:987415322427:web:276bdc2c52f3360648211e"
};

// Inicialização do Firebase
let app, auth, db, functions;

try {
  // Verificar se as configurações são válidas (não são placeholders)
  if (firebaseConfig.apiKey && firebaseConfig.projectId &&
      firebaseConfig.apiKey !== "YOUR_FIREBASE_API_KEY" &&
      firebaseConfig.projectId !== "YOUR_FIREBASE_PROJECT_ID") {

    console.log("🔄 Inicializando Firebase...");
    console.log("📋 Projeto:", firebaseConfig.projectId);

    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    functions = getFunctions(app);

    // Habilitar rede do Firestore
    enableNetwork(db);

    console.log("✅ Firebase inicializado com sucesso!");
    console.log("📊 Firestore conectado:", firebaseConfig.projectId);
    console.log("🔐 Auth configurado:", !!auth);
    console.log("💾 Database configurado:", !!db);
  } else {
    console.warn("⚠️ Configuração do Firebase não fornecida ou usando placeholders.");
    console.warn("🎭 Modo demonstração ativado - funcionalidades limitadas.");
    console.log("📝 Para configurar o Firebase, siga as instruções em CONFIGURAR_FIREBASE.md");
  }
} catch (error) {
  console.error("❌ Erro ao inicializar o Firebase:", error);
  console.error("🔧 Verifique suas configurações do Firebase");
}

// Estrutura de coleções do Firestore para SaaS multi-usuário
export const COLLECTIONS = {
  // 🏢 MULTITENANCY - SAAS
  TENANTS: 'tenants',
  TENANT_USERS: 'tenantUsers',
  BILLING: 'billing',
  SUBSCRIPTIONS: 'subscriptions',
  
  // Usuários e suas configurações
  USERS: 'users',
  USER_OABS: 'userOabs',
  USER_SETTINGS: 'userSettings',

  // Processos por usuário
  USER_PROCESSOS: 'userProcessos',

  // Monitoramento automático
  MONITORING_JOBS: 'monitoringJobs',
  MONITORING_LOGS: 'monitoringLogs',

  // Comunicações PJe (cache global)
  PJE_COMUNICACOES: 'pjeComunicacoes',
  PJE_CACHE: 'pjeCache',

  // Notificações
  NOTIFICATIONS: 'notifications',

  // Analytics e métricas
  ANALYTICS: 'analytics',
  USER_ACTIVITY: 'userActivity'
};

export { auth, db, functions };
export default app;
